import React, { Component } from 'react';
import { connect } from "react-redux";

import SHNavbar from './Navbar.jsx';
import EUNavbar from './EndUser/EU-Navbar.jsx';

import {constants} from "../Helpers/Constants";

//A React component will allow us to quickly iterate and change our code. It provides 
class NavbarSelector extends Component {
    constructor(props) {
        super(props);

        this.state = {
        };
    }

    componentDidMount() {
    }

    componentWillReceiveProps(nextProps) {
    }

    render() {
        if(this.props.userSession.user.user_type < constants.user_type.user)
        {
            return (
                <SHNavbar history={this.props.history} match={this.props.match} location={this.props.location}/>
            )
        } else {
            return (
                <EUNavbar history={this.props.history} match={this.props.match} location={this.props.location}/>
            )
        }
    }
}

const mapStateToProps = store => ({
    userSession: store.userSession
});

export default connect(mapStateToProps)(NavbarSelector);